/*!
 * Audiocity — Cotización compartible (26 oct 2026).
 * 1) Botón "Compartir cotización" en el carrito: genera un enlace /cart?ac_cot=VARIANTE:CANT,...
 *    y lo comparte (menú del celular) o lo copia, con opción de enviarlo por WhatsApp.
 * 2) Al abrir ese enlace, la página del carrito ofrece cargar esos productos (reemplaza el carrito).
 */
(function () {
  'use strict';
  if (window.__acCompartir) return;
  window.__acCompartir = true;

  function raiz() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  function jsonFetch(url, opts) {
    return fetch(url, Object.assign({ credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts || {}))
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error((j && (j.description || j.message)) || 'Error'); return j; }); });
  }

  /* ---------- Generar enlace ---------- */
  function enlaceDesdeCarrito() {
    return jsonFetch(raiz() + 'cart.js').then(function (cart) {
      var partes = (cart.items || []).map(function (it) { return it.variant_id + ':' + it.quantity; });
      if (!partes.length) throw new Error('El carrito está vacío.');
      return { url: location.origin + raiz() + 'cart?ac_cot=' + partes.join(','), cart: cart };
    });
  }
  function copiar(texto) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(texto);
    return new Promise(function (ok, mal) {
      try {
        var t = document.createElement('textarea');
        t.value = texto; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
        document.body.appendChild(t); t.select(); document.execCommand('copy'); document.body.removeChild(t); ok();
      } catch (e) { mal(e); }
    });
  }
  function alCompartir(boton) {
    var caja = boton.closest('[data-ac-compartir]');
    var estado = caja && caja.querySelector('[data-ac-compartir-estado]');
    function decir(html) { if (estado) estado.innerHTML = html; }
    decir('Generando enlace…');
    enlaceDesdeCarrito().then(function (r) {
      var total = Math.round((r.cart.total_price || 0) / 100);
      var texto = 'Cotización de Audiocity (' + r.cart.item_count + ' productos, total $' + new Intl.NumberFormat('es-CO').format(total) + ' IVA incluido). Ábrala aquí para revisarla o pagarla:';
      if (navigator.share && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
        return navigator.share({ title: 'Cotización Audiocity', text: texto, url: r.url }).then(function () { decir(''); }).catch(function () { decir(''); });
      }
      return copiar(r.url).then(function () {
        decir('Enlace copiado. Péguelo donde quiera o <a href="https://wa.me/?text=' + encodeURIComponent(texto + ' ' + r.url) + '" target="_blank" rel="noopener">envíelo por WhatsApp</a>.');
      }).catch(function () {
        decir('Copie este enlace: <input type="text" readonly value="' + r.url.replace(/"/g, '&quot;') + '" style="width:100%" onclick="this.select()">');
      });
    }).catch(function (e) { decir(e.message || 'No fue posible generar el enlace.'); });
  }
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-ac-compartir-boton]');
    if (b) { ev.preventDefault(); alCompartir(b); }
  });

  /* ---------- Cargar un enlace recibido ---------- */
  function leerParam() {
    try {
      var p = new URLSearchParams(location.search).get('ac_cot');
      if (!p) return null;
      var items = p.split(',').map(function (x) {
        var m = x.split(':');
        var id = parseInt(m[0], 10), q = parseInt(m[1], 10);
        return id > 0 && q > 0 ? { id: id, quantity: Math.min(q, 999) } : null;
      }).filter(Boolean);
      return items.length ? items.slice(0, 100) : null;
    } catch (e) { return null; }
  }
  function ofrecerCarga() {
    var items = leerParam();
    if (!items) return;
    var unidades = items.reduce(function (s, i) { return s + i.quantity; }, 0);
    if (!document.getElementById('ac-compartir-css')) {
      var st = document.createElement('style');
      st.id = 'ac-compartir-css';
      st.textContent = '.ac-compartir-aviso{padding:16px;background:#0682B60f;border-bottom:1px solid #0682B633}.ac-compartir-aviso__in{max-width:1200px;margin:0 auto}.ac-compartir-aviso p{margin:0 0 10px}.ac-compartir-aviso__acc{display:flex;gap:10px;flex-wrap:wrap}';
      document.head.appendChild(st);
    }
    var aviso = document.createElement('div');
    aviso.className = 'ac-compartir-aviso';
    aviso.setAttribute('role', 'region');
    aviso.setAttribute('aria-label', 'Cotización compartida');
    aviso.innerHTML = '<div class="ac-compartir-aviso__in"><p><strong>Le compartieron una cotización</strong> con ' + items.length + ' referencia' + (items.length > 1 ? 's' : '') + ' (' + unidades + ' unidad' + (unidades > 1 ? 'es' : '') + '). Al cargarla se reemplaza lo que tenga en su carrito.</p><div class="ac-compartir-aviso__acc"><button type="button" class="button" data-ac-cargar>Cargar cotización</button><button type="button" class="button button-secondary" data-ac-descartar>Ahora no</button></div><p class="ac-compartir-aviso__estado" role="status" aria-live="polite"></p></div>';
    var destino = document.querySelector('main') || document.body;
    destino.insertBefore(aviso, destino.firstChild);
    var est = aviso.querySelector('.ac-compartir-aviso__estado');
    aviso.querySelector('[data-ac-descartar]').addEventListener('click', function () {
      aviso.remove();
      try { history.replaceState(null, '', location.pathname); } catch (e) {}
    });
    aviso.querySelector('[data-ac-cargar]').addEventListener('click', function (ev) {
      ev.currentTarget.disabled = true;
      est.textContent = 'Cargando productos…';
      jsonFetch(raiz() + 'cart/clear.js', { method: 'POST', body: '{}' })
        .then(function () { return jsonFetch(raiz() + 'cart/add.js', { method: 'POST', body: JSON.stringify({ items: items }) }); })
        .then(function () { location.href = raiz() + 'cart'; })
        .catch(function (e) {
          est.textContent = 'Algunos productos ya no están disponibles. ' + (e.message || '');
          setTimeout(function () { location.href = raiz() + 'cart'; }, 2500);
        });
    });
  }
  if (/\/cart\/?$/.test(location.pathname)) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ofrecerCarga);
    else ofrecerCarga();
  }
})();